export default function Contact() {
    return (
        <section id="contact" className="contact-section py-5">
            <div className="container">
                <h2 className="section-title text-center mb-5">Contact Us</h2>
                <div className="row align-items-stretch">

                    {/* Address + Map */}
                    <div className="col-md-6 mb-4">
                        <div className="contact-info p-4 rounded shadow-lg h-100">
                            <h3 className="text-light mb-3">Head Office</h3>
                            <ul className="list-unstyled text-light-emphasis small">
                                <li><strong>Email:</strong> anandtechplastltd@gmail.com</li>
                                <li><strong>Building No.:</strong> PLOT NO.5-6, 13-14</li>
                                <li><strong>Company:</strong> Anand Tech Plast Pvt Ltd</li>
                                <li><strong>Street:</strong> Industrial Area Plastic Park Tamot</li>
                                <li><strong>City:</strong> Raisen</li>
                                <li><strong>District:</strong> Raisen</li>
                                <li><strong>State:</strong> Madhya Pradesh</li>
                                <li><strong>PIN Code:</strong> 464990</li>
                            </ul>
                            <div className="map-container mt-3">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83961974178!2d77.06889731440485!3d28.52712235117467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1dc1d7d7c1b7%3A0xc1c5d6d3d8d7d7d7!2sDelhi%2C%20India!5e0!3m2!1sen!2sus!4v1599999999999"
                                    width="100%"
                                    height="200"
                                    style={{ border: 0, borderRadius: "10px" }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    title="Company Location"
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="col-md-6 mb-4">
                        <div className="contact-form p-4 rounded shadow-lg h-100">
                            <h4 className="text-light mb-3">Send Us a Message</h4>
                            <form>
                                <input type="text" className="form-control mb-3" placeholder="Your Name" />
                                <input type="email" className="form-control mb-3" placeholder="Your Email" />
                                <textarea className="form-control mb-3" rows="4" placeholder="Your Message"></textarea>
                                <button className="btn btn-light w-100 fw-bold">Send Message</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
